import type { ComparisonConfig } from './ComparisonPage';

const OPERA_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-opera',
  competitorName: 'Oracle OPERA',
  heroTitle: 'HotelStack.io vs Oracle OPERA',
  heroSubtitle: 'Oracle OPERA es el estándar heredado de la industria — construido hace décadas y aún cargando la complejidad y los precios de la era empresarial. HotelStack.io ofrece una alternativa moderna, nativa en la nube, con más módulos, precios más simples y cero sobrecarga de infraestructura.',
  overviewComparison: [
    { label: 'Arquitectura', hotelstack: 'SaaS Nativo en la Nube', competitor: 'Local Heredado / Nube' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: '$500+/mes + Licencias' },
    { label: 'Implementación', hotelstack: 'Gratis — Incorporación en 48h', competitor: 'Implementación de 3-6 Meses' },
    { label: 'Módulos Totales', hotelstack: '36 Integrados', competitor: '20+ (Licencias Separadas)' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'Licencia POS OPERA Separada' },
    { label: 'Segmento Objetivo', hotelstack: 'PYME a Empresarial', competitor: 'Solo Empresarial' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Gestión de Folio del Huésped', hotelstack: true, competitor: true },
        { name: 'Reservas Grupales', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: 'Complemento' },
      ],
    },
    {
      category: 'Nube y Accesibilidad',
      features: [
        { name: 'Verdaderamente Nativo en la Nube', hotelstack: true, competitor: 'Híbrido' },
        { name: 'Cero Mantenimiento de Servidores', hotelstack: true, competitor: false },
        { name: 'Sincronización Multi-Dispositivo en Tiempo Real', hotelstack: true, competitor: 'Limitado' },
        { name: 'Interfaz Moderna Responsiva', hotelstack: true, competitor: false },
        { name: 'Actualizaciones Automáticas', hotelstack: true, competitor: false },
        { name: 'Sin Personal de TI Necesario', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Gestión de Ingresos',
      features: [
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: true },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: 'Vía Oracle BI' },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: true },
        { name: 'Analíticas RevPAR', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'A&B y Operaciones',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: 'Licencia Separada' },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: 'Licencia Separada' },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
        { name: 'Programación de Personal', hotelstack: true, competitor: false },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: 'Vía Integración' },
      ],
    },
    {
      category: 'Coste e Incorporación',
      features: [
        { name: 'Incorporación Gratuita', hotelstack: true, competitor: false },
        { name: 'Migración de Datos Gratuita', hotelstack: true, competitor: false },
        { name: 'Sin Costes de Servidor', hotelstack: true, competitor: false },
        { name: 'Sin Tarifas de Licencia', hotelstack: true, competitor: false },
        { name: 'Precios en Moneda Regional', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: 'Complemento' },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Complemento' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: 'Complemento' },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: 'Complemento Micros' },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: 'Vía Integración' },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$500+',
    hotelstackNote: 'Los 36 módulos incluidos. Sin tarifas de licencia. Sin costes de servidor. Incorporación y migración gratuitas. Precios regionales en EUR, GBP, AED, INR, THB.',
    competitorNote: 'Licenciamiento empresarial desde $500+/mes por propiedad. Licencias separadas de POS, S&C y OCRM. Tarifas de implementación desde $50,000+. Servidores locales requeridos para la edición clásica.',
  },
  advantages: [
    'Más del 90% menos de coste total de propiedad — sin tarifas de licencia, costes de servidor ni cargos de implementación',
    'En producción en 48 horas vs 3-6 meses de implementación con OPERA',
    'Interfaz moderna nativa en la nube accesible desde cualquier dispositivo — sin cliente de escritorio necesario',
    'Los 36 módulos incluidos en una suscripción vs licencias separadas por módulo en OPERA',
    'Cero infraestructura de TI — sin servidores, sin parches, sin DBA de Oracle requerido',
    'A&B y POS integrados sin coste adicional vs licenciamiento POS OPERA separado',
    'Precios regionales en 6 monedas para que los hoteles paguen en moneda local',
    'Migración de datos gratuita desde OPERA con equipo de soporte dedicado',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'Oracle OPERA ha sido el estándar de la industria durante décadas y sigue siendo una opción sólida para grandes cadenas empresariales con infraestructura Oracle existente. Sin embargo, para la gran mayoría de hoteles, HotelStack.io ofrece más módulos, mejor UX y costes drásticamente menores sin los ciclos de implementación prolongados, la sobrecarga de servidores y el licenciamiento complejo que OPERA exige.',
    bestFor: [
      'Hoteles que desean eliminar costosas licencias e infraestructura Oracle',
      'Propiedades cansadas de los lentos ciclos de implementación y actualización de OPERA',
      'Hoteles que necesitan una interfaz moderna nativa en la nube sin dependencias de cliente de escritorio',
      'Hoteles PYME y de escala media excluidos por los planes empresariales de OPERA',
      'Propiedades que desean todos los módulos incluidos sin tarifas de licencia separadas',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de Oracle OPERA a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración se especializa en transiciones de OPERA a HotelStack. Importamos perfiles de huéspedes, historial de reservas, códigos de tarifas, configuraciones de habitaciones y bloques grupales. La migración es gratuita y normalmente se completa en 48-72 horas sin tiempo de inactividad.' },
    { question: '¿HotelStack.io soporta las mismas integraciones que OPERA?', answer: 'HotelStack.io se conecta a más de 100 OTAs, GDS vía Amadeus y Sabre, y las principales pasarelas de pago. Nuestro marketplace de integraciones cubre el mismo ecosistema. También proporcionamos una API abierta para integraciones personalizadas.' },
    { question: '¿Cómo se compara HotelStack.io con OPERA Cloud?', answer: 'OPERA Cloud es la modernización de Oracle de su producto heredado. HotelStack.io fue construido como nativo en la nube desde el primer día con tecnología moderna. Ofrecemos más módulos (36 vs base de OPERA Cloud), precios más simples, incorporación más rápida y sin dependencia de infraestructura Oracle.' },
    { question: '¿Es HotelStack.io adecuado para grandes cadenas hoteleras actualmente en OPERA?', answer: 'Sí. Nuestros planes Cadena y Empresarial soportan gestión multi-propiedad con analíticas centralizadas, distribución de tarifas y estándares de marca — las mismas capacidades que mantienen a las grandes cadenas en OPERA, a una fracción del coste.' },
  ],
};

const RMS_CLOUD_ES: ComparisonConfig = {
  slug: 'hotelstack-vs-rms-cloud',
  competitorName: 'RMS Cloud',
  heroTitle: 'HotelStack.io vs RMS Cloud',
  heroSubtitle: 'RMS Cloud sirve al mercado hotelero de APAC con sólidos fundamentos de PMS. HotelStack.io amplía eso con 36 módulos, precios multidivisa globales, A&B/POS integrados y gestión avanzada de ingresos — todo a un precio más bajo.',
  overviewComparison: [
    { label: 'Módulos Totales', hotelstack: '36 Módulos Integrados', competitor: 'Más de 12 Módulos' },
    { label: 'Precios', hotelstack: 'Desde $49/mes', competitor: 'Desde $80+/mes' },
    { label: 'Alcance Global', hotelstack: 'Más de 40 Países', competitor: 'Principalmente APAC' },
    { label: 'A&B / POS', hotelstack: 'Integrado', competitor: 'No Disponible' },
    { label: 'Gestión de Ingresos', hotelstack: 'Avanzada (Integrada)', competitor: 'Básica' },
    { label: 'Motor de Reservas', hotelstack: 'BookMyRoom.io (Gratis)', competitor: 'Widget Básico' },
  ],
  featureTable: [
    {
      category: 'PMS Principal',
      features: [
        { name: 'PMS en la Nube', hotelstack: true, competitor: true },
        { name: 'Tablero Visual de Habitaciones', hotelstack: true, competitor: true },
        { name: 'Gestión de Reservas', hotelstack: true, competitor: true },
        { name: 'Asistente de Auditoría Nocturna', hotelstack: true, competitor: true },
        { name: 'Reservas Grupales', hotelstack: true, competitor: true },
        { name: 'Portal de Check-In en Línea', hotelstack: true, competitor: 'Limitado' },
      ],
    },
    {
      category: 'Ingresos y Distribución',
      features: [
        { name: 'Channel Manager (100+ OTAs)', hotelstack: true, competitor: 'OTAs Limitadas' },
        { name: 'Reglas de Precios Dinámicos', hotelstack: true, competitor: false },
        { name: 'Monitor de Tarifas de la Competencia', hotelstack: true, competitor: false },
        { name: 'Simulador de Ingresos Hipotético', hotelstack: true, competitor: false },
        { name: 'Previsión de Demanda', hotelstack: true, competitor: 'Básico' },
        { name: 'Analíticas RevPAR', hotelstack: true, competitor: 'Básico' },
      ],
    },
    {
      category: 'Gestión de Huéspedes',
      features: [
        { name: 'Perfiles de Huésped 360 Grados', hotelstack: true, competitor: 'Básico' },
        { name: 'Gestión de Programa de Fidelización', hotelstack: true, competitor: false },
        { name: 'Automatización de Comunicación con Huéspedes', hotelstack: true, competitor: 'Limitado' },
        { name: 'Analíticas de Gasto del Huésped', hotelstack: true, competitor: false },
        { name: 'Carga y Verificación de ID', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'A&B y Operaciones',
      features: [
        { name: 'Terminal POS', hotelstack: true, competitor: false },
        { name: 'Módulo de Servicio a Habitación', hotelstack: true, competitor: false },
        { name: 'Sistema de Pantalla de Cocina', hotelstack: true, competitor: false },
        { name: 'Gestión de Limpieza', hotelstack: true, competitor: true },
        { name: 'Órdenes de Trabajo de Mantenimiento', hotelstack: true, competitor: false },
        { name: 'Programación y Nómina de Personal', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Multi-Propiedad y Cumplimiento',
      features: [
        { name: 'Panel de Cadena', hotelstack: true, competitor: true },
        { name: 'Analíticas entre Propiedades', hotelstack: true, competitor: 'Limitado' },
        { name: 'Facturación Multidivisa', hotelstack: true, competitor: 'Enfoque AUD' },
        { name: 'Cumplimiento Fiscal Regional', hotelstack: true, competitor: 'Solo APAC' },
        { name: 'Protección de Datos GDPR', hotelstack: true, competitor: 'Limitado' },
      ],
    },
    {
      category: 'Resiliencia y Sin Conexión',
      features: [
        { name: 'PWA con Capacidad Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Cola de Cambios Sin Conexión', hotelstack: true, competitor: false },
        { name: 'Sincronización en Segundo Plano al Reconectar', hotelstack: true, competitor: false },
        { name: 'Reconciliación con Detección de Conflictos', hotelstack: true, competitor: false },
        { name: 'Recepción Instalable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventas Corporativas y de Grupos',
      features: [
        { name: 'Gestión de Tarifas Corporativas', hotelstack: true, competitor: false },
        { name: 'Reserva de Grupo con Listas de Habitaciones', hotelstack: true, competitor: 'Limitado' },
        { name: 'Informes de Antigüedad de Saldos y Producción', hotelstack: true, competitor: false },
        { name: 'Reservas de Restaurante', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personal y RR. HH.',
      features: [
        { name: 'Directorio de Personal y Turnos', hotelstack: true, competitor: false },
        { name: 'Procesamiento de Nómina', hotelstack: true, competitor: false },
        { name: 'Permisos y Asistencia', hotelstack: true, competitor: false },
        { name: 'Analíticas de Desempeño', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$80+',
    hotelstackNote: 'Los 36 módulos incluidos. Precios regionales en EUR, GBP, AED, INR, THB. Incorporación y migración de datos gratuitas.',
    competitorNote: 'Precios basados en AUD desde $80+/mes. Cargos adicionales por channel manager y funciones premium. Soporte principalmente en APAC.',
  },
  advantages: [
    'Casi el triple de módulos (36 vs 12+) con todas las funciones incluidas a un precio más bajo',
    'Cobertura global en más de 40 países vs enfoque de RMS Cloud en mercados APAC',
    'Módulo completo de A&B con terminal POS, servicio a habitación y gestión de cocina',
    'Gestión avanzada de ingresos con precios dinámicos, previsión y simuladores',
    'Conectividad de canales más fuerte con más de 100 OTAs y GDS vía Amadeus y Sabre',
    'Gestión de personal con programación, nóminas, asistencia y seguimiento de rendimiento',
    'Facturación multidivisa en 6 monedas vs precios principalmente basados en AUD',
    'Incorporación y migración de datos gratuitas con soporte dedicado 24/7',
  ],
  verdict: {
    title: 'Nuestro Veredicto',
    summary: 'RMS Cloud es un PMS capaz para propiedades APAC con sólidos fundamentos para la gestión de alojamiento. HotelStack.io ofrece una solución más completa con 36 módulos, alcance global, gestión avanzada de ingresos y capacidades completas de A&B/POS — todo a un precio más bajo. Para propiedades que buscan ir más allá del PMS básico hacia la gestión integral de operaciones hoteleras, HotelStack.io es la opción más sólida.',
    bestFor: [
      'Hoteles que desean una plataforma integral completa más allá del PMS básico',
      'Propiedades que necesitan A&B, POS y gestión de cocina integrados',
      'Hoteles expandiéndose fuera de APAC que necesitan cumplimiento y distribución global',
      'Propiedades que desean gestión avanzada de ingresos y precios dinámicos',
      'Cadenas multi-propiedad que necesitan analíticas centralizadas en propiedades globales',
    ],
  },
  faqItems: [
    { question: '¿Puedo migrar de RMS Cloud a HotelStack.io?', answer: 'Sí. Nuestro equipo de migración gestiona la transferencia completa de datos desde RMS Cloud incluyendo perfiles de huéspedes, historial de reservas, configuraciones de tarifas y configuraciones de habitaciones. La migración es gratuita y normalmente se completa en 48 horas sin tiempo de inactividad.' },
    { question: '¿Funciona bien HotelStack.io para hoteles en Australia y APAC?', answer: 'Por supuesto. HotelStack.io soporta facturación multidivisa incluyendo AUD, cumplimiento fiscal regional para mercados APAC y conexiones con OTAs enfocadas en APAC. Muchas de nuestras propiedades en APAC cambiaron desde RMS Cloud por los módulos adicionales y el alcance global.' },
    { question: '¿Cómo se comparan los precios de HotelStack.io con RMS Cloud?', answer: 'HotelStack.io comienza en $49/mes con los 36 módulos incluidos y precios regionales en 6 monedas. RMS Cloud comienza en aproximadamente $80+/mes AUD con menos módulos y cargos adicionales por gestión de canales y funciones premium.' },
    { question: '¿Soporta HotelStack.io parques vacacionales y campings como RMS Cloud?', answer: 'HotelStack.io está diseñado para todo tipo de alojamiento incluyendo hoteles, resorts, hostales, propiedades boutique y apartamentos con servicios. Aunque RMS Cloud tiene funciones específicas para parques vacacionales, la flexibilidad de configuración de HotelStack.io soporta diversos modelos de alojamiento.' },
  ],
};

export const COMPARISON_ES_P2: Record<string, ComparisonConfig> = {
  'hotelstack-vs-opera': OPERA_ES,
  'hotelstack-vs-rms-cloud': RMS_CLOUD_ES,
};
